if (!customElements.get("pagination-element")) {
  class PaginationElement extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute("ajax")) {
        delegate(this, "click", "a", this.onLinkClicked.bind(this));
      }
    }

    onLinkClicked(event, target) {
      event.preventDefault();
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set("page", target.getAttribute("data-page"));

      triggerEvent(this, "pagination:page-changed", {
        searchParams: searchParams.toString(),
      });
    }
  }
  window.customElements.define("pagination-element", PaginationElement);
}
